<!-- =========================================================================================
    File Name: NotAuthorized.vue
    Description: Not Authorized Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
      <p class="sm:mx-0 mx-4 sm:mb-12 mb-8 d-theme-text-inverse font-30">有効なメニュー・プランがございませんでした。</p>
    </div>
  </div>
</template>

<script>
// 認証エラー画面表示時には、検索時に表示される応答待ちアイコンを強制的に非表示化する
// TODO もっと良い回避策があるはず。改善の余地あり。
const ele = document.getElementsByClassName('app-spinner');
if (ele != null && ele.length > 0) {
  ele[0].style.display = 'none';
}
</script>

<style lang="scss" scoped>
.link-back {
  color: #333;
  font-weight: 700;
  font-size: 18px;
}
.font-30 {
  font-size: 30px
}
</style>
